import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getUserById } from "../Apis/Users/Users";
import { GetAllUsersAutocomplete } from "../Apis/Autocompleteapi"
import { GetAllUsers } from "../Apis/Users/Users";



export const fetchGetallUsers = createAsyncThunk(
  "Users/fetchAll",
  async ({ page = 1, limit = 10,filters={}}, { rejectWithValue }) => {
    try {
      const response = await GetAllUsers({ page, limit,filters});
      return {
        data: response.data,
        pagination: {
          page: response.page,
          total: response.total,
          totalPages: response.totalPages,
          limit: response.limit || limit,
        }
      };
    } catch (error) {
      return rejectWithValue({
        status: error.status || 500,
        message: error.message || "Failed to fetch reservations",
      });
    }
  }
);

export const fetchUsersAutocomplete = createAsyncThunk(
  "usersAutocomplete/fetchAll",
  async ({ page, limit }, { rejectWithValue }) => {
    try {
      const response = await GetAllUsersAutocomplete(page, limit);
      return {
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      return rejectWithValue({
        status: error.status || 500,
        message: error.message || "Failed to fetch users",
      });
    }
  }
);

export const fetchgetUserById = createAsyncThunk(
  'getUserById/fetchgetUserById',
  async (id) => {
    const response = await getUserById(id);
    return response;
  }
);

const initialState = {
  data: [],
  isLoading: false,
  error: null,
  pagination: {
    page: 1,
    pageSize: 10,  
    total: 0,
    totalPages: 0,
  },
}

const UserSlice = createSlice({
  name: 'Users',
  initialState,
  extraReducers: (builder) => {
    builder
    .addCase(fetchUsersAutocomplete.pending, (state) => {
      state.isLoading = true;
      state.error = null;
      state.status = null;
    })
    .addCase(fetchUsersAutocomplete.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload.data;
      state.status = action.payload.status
    })
    .addCase(fetchUsersAutocomplete.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload.message;
      state.status = action.payload.status;
      state.data = [];
    })
      .addCase(fetchgetUserById.pending, (state) => {
        state.isLoading = true;
        state.data = {};
      })
      .addCase(fetchgetUserById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.data;
      })
      .addCase(fetchGetallUsers.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchGetallUsers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.data;
        state.pagination = {
          page: action.payload.pagination.page,
          pageSize: action.payload.pagination.limit, 
          total: action.payload.pagination.total,
          totalPages: action.payload.pagination.totalPages,
        };
      })
      .addCase(fetchGetallUsers.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.message || "Failed to fetch users";
      });
  }
});

export default UserSlice.reducer;
